import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Agent from 'models/agent';
import { CHANNEL_REPLY_TEXT } from 'components/lib/channel_action_text';
import connect from 'components/lib/connect';
import ConversationItem, { getOutgoingCommunicationStatus } from 'models/conversation_item';
import { iconClassNameForItem } from './metadata_icon_classes';
import ItemPrepositionalPhrases from './item_prepositional_phrases';
import Metadata from './metadata';
import { typeReflect } from 'models/conversation_item/content_from_js';

export function AgentMetadata({
  agent,
  currentAgentId,
  hasError,
  icon,
  iconClass,
  isCollapsed,
  item,
  prepositionalPhrases,
  object,
  status,
  subject,
  text,
  tooltip,
}) {
  hasError = hasError != null ? hasError : item.content.hasErrorStatus && item.content.hasErrorStatus();
  iconClass = iconClass != null ? iconClass : iconClassNameForItem(item);
  status = status != null ? status : getOutgoingCommunicationStatus(item);
  subject = subject != null ? subject : getAgentName(agent, currentAgentId);
  text = text != null ? text : `replied via ${CHANNEL_REPLY_TEXT[typeReflect.instanceToType(item.content)]}`;

  return (
    <Metadata
      hasError={hasError}
      icon={icon}
      iconClass={iconClass}
      isCollapsed={isCollapsed}
      isInbound={false}
      object={object}
      prepositionalPhrases={prepositionalPhrases || <ItemPrepositionalPhrases item={item} />}
      status={status}
      subject={subject}
      text={text}
      timestamp={item.timestamp}
      tooltip={tooltip}
    />
  );
}

function getAgentName(agent, currentAgentId) {
  if (!agent) {
    return 'An agent';
  } else if (currentAgentId === agent.id) {
    return 'You';
  }
  return agent.name;
}

AgentMetadata.propTypes = {
  agent: PropTypes.instanceOf(Agent),
  currentAgentId: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  icon: PropTypes.node,
  iconClass: PropTypes.string,
  isCollapsed: PropTypes.bool,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  prepositionalPhrases: PropTypes.node,
  object: PropTypes.string,
  status: PropTypes.string,
  subject: PropTypes.node,
  text: PropTypes.any,
  tooltip: PropTypes.string,
};

function mapStateToProps({ getProvider }, props) {
  const currentAgentId = getProvider('currentAgent').get().id;
  const agent = getProvider('agents').findBy({ id: _.get(props, 'item.initiator.id') });

  return {
    ...props,
    agent,
    currentAgentId,
  };
}

const AgentMetadataContainer = connect(mapStateToProps)(AgentMetadata);
AgentMetadataContainer.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

export default AgentMetadataContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/metadata/agent_metadata.jsx